/**
 * Markup for the about us modal
 * @returns string
 */
export default function getDiscountModal() {
  return `
  <iframe class="max-w-[100%]" width="560" height="315" src="https://www.youtube.com/embed/iHLIAAl-ETI?si=UjzeZsGdEvxF25zr" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
  `;
}
